export default __webpack_public_path__ + "static/131-d0af70341f12a20f5cd39aef075085e2.gif";